<div class="item">
    <div class="item-container">
        <span class="regNo">{{ $ctrl.item.regNo }}</span>
        <span class="title">{{ $ctrl.item.title }}</span>
    </div>
    <span ng-if="$ctrl.item.isEditable" ng-click="$ctrl.removeItem()" class="item-icon fa fa-times hover-effects"></span>
</div>